const PG_PREFIX = 'pg:'
const SEPARATOR = '/'

/**
 * Single owner of the composite ids used by the picker forest.
 *
 * Invariant: a product group id is a UUID (`ProductGroupModel.id` is
 * `@format uuid`), so it can never contain `/` or `:`. That's the only
 * reason `<pgId>/<catId>` and `pg:<pgId>` parse unambiguously below — if a
 * pgId ever stopped being a UUID, this scheme would break.
 */
export const nodeId = {
	pg: (pgId: string) => `${PG_PREFIX}${pgId}`,
	cat: (pgId: string, catId: string) => `${pgId}${SEPARATOR}${catId}`,
	parse: (id: string): { pgId: string; catId?: string } => {
		if (id.startsWith(PG_PREFIX)) return { pgId: id.slice(PG_PREFIX.length) }
		const index = id.indexOf(SEPARATOR)
		if (index === -1) return { pgId: id }

		return { pgId: id.slice(0, index), catId: id.slice(index + 1) }
	},
}
